export const galleryImages = [
  { src: '/images/gallery/Training-1.jpg', alt: 'Training session 1' },
  { src: '/images/gallery/Training-2.jpg', alt: 'Training session 2' },
  { src: '/images/gallery/Training-3.jpg', alt: 'Training session 3' },
  { src: '/images/gallery/Training-4.jpg', alt: 'Training session 4' },
  { src: '/images/gallery/Training-7.jpeg', alt: 'Training session 5' },
  { src: '/images/gallery/Training-8.jpg', alt: 'Training session 6' },
  { src: '/images/gallery/Training-9.jpg', alt: 'Training session 7' },
  { src: '/images/gallery/Field-visit.jpg', alt: 'Field visit' },
  { src: '/images/gallery/Training-5.jpg', alt: 'Training session 8' },
  { src: '/images/gallery/News-4.jpg', alt: 'News coverage 1' },
  { src: '/images/gallery/News-3.jpeg', alt: 'News coverage 2' },
  { src: '/images/gallery/News-7.jpeg', alt: 'News coverage 3' },
  { src: '/images/gallery/News-1.jpeg', alt: 'News coverage 4' },
  { src: '/images/gallery/News-5.jpeg', alt: 'News coverage 5' },
  { src: '/images/gallery/News-6.jpeg', alt: 'News coverage 6' },
  { src: '/images/gallery/News-2.jpeg', alt: 'News coverage 7' },
];

export const galleryDescription =
  'Capacity Building on Crop Diversification and High Value Horticulture Crop Production - Lapra Panchayat, Khalari Block, Ranchi District, Jharkhand for FY 2025-26 through CMPDI.';
